import React, { FC, useContext } from 'react';

import { TimeOutInput } from 'components';
import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

import s from './ExpiredBooking.module.scss';

export const ExpiredBooking: FC = () => {
  const { t } = useContext(LocalizationContext);
  const {
    state: { settings },
    actions: { setSetting },
  } = useContext(SettingsContext);

  return (
    <div className={s.container}>
      <TimeOutInput
        label={t('setting.booking.expiration.title')}
        description={t('setting.booking.expiration.description')}
        setting={settings.bookingExpirationThreshold}
        updateSetting={setSetting}
        settingAlias={ESettingsAliases.BOOKING_EXPIRATION_THRESHOLD}
        inMinutes
        maxMinutes={60}
        minMinutes={0}
        zero={true}
      />
    </div>
  );
};
